import { useState } from "react";
import { X, Check } from "lucide-react";
import useDesignItems from "@features/design/hooks/useDesignItems";
import useSpaceGallery from "@features/dashboard/hooks/useSpaceGallery";

const TABS = ["Design Book", "Gallery"];

export default function HeroImagePicker({ currentUrl, onSelect, onClose }) {
  const [tab, setTab] = useState(0);
  const { items: designItems } = useDesignItems();
  const { images: galleryImages } = useSpaceGallery();

  const designImages = designItems.filter((it) => it.imageUrl);
  const sources = tab === 0 ? designImages : galleryImages;
  const getUrl = (src) => (tab === 0 ? src.imageUrl : src.imageUrl);

  return (
    <div
      className="fixed inset-0 z-[200] flex flex-col"
      style={{ background: "rgba(0,0,0,0.88)", backdropFilter: "blur(6px)" }}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 flex-shrink-0" style={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <h2 className="text-sm font-semibold text-white">Choose cover photo</h2>
        <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-white/[0.08] text-gray-300 transition-colors">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 px-4 pt-3 pb-2 flex-shrink-0">
        {TABS.map((label, i) => (
          <button
            key={label}
            onClick={() => setTab(i)}
            className="px-3 py-1.5 rounded-full text-xs font-semibold transition-colors"
            style={
              tab === i
                ? { background: "rgb(99 102 241)", color: "white" }
                : { background: "rgba(255,255,255,0.07)", color: "rgba(255,255,255,0.5)" }
            }
          >
            {label}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="flex-1 overflow-y-auto px-4 pb-8">
        {sources.length === 0 ? (
          <p className="text-sm text-center py-12" style={{ color: "rgba(255,255,255,0.35)" }}>
            No images in {TABS[tab]} yet.
          </p>
        ) : (
          <div className="grid grid-cols-3 md:grid-cols-4 gap-2 pt-2">
            {sources.map((src) => {
              const url = getUrl(src);
              const isActive = url === currentUrl;
              return (
                <button
                  key={src.id}
                  onClick={() => { onSelect(url); onClose(); }}
                  className="relative aspect-square rounded-lg overflow-hidden transition-transform hover:scale-[1.03] active:scale-[0.97]"
                  style={{
                    outline: isActive ? "2.5px solid rgb(99 102 241)" : "none",
                    outlineOffset: "2px",
                  }}
                >
                  <img
                    src={url}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                  {isActive && (
                    <div className="absolute inset-0 flex items-center justify-center" style={{ background: "rgba(99,102,241,0.35)" }}>
                      <div className="w-7 h-7 rounded-full bg-indigo-500 flex items-center justify-center">
                        <Check className="w-4 h-4 text-white" />
                      </div>
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
